var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReliableAvailableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 53V41.5L17.5 40.5L19 39L21 38L22.5 37L25 36.5L26 36H28L33.5 36.5L35.5 37L37 37.5L38.5 38.5L39 39.5L39.5 40.5V42L39 43.5L38.5 44.5L36 45.5H37.5H39.5L41 44.5L44 42.5L46 41L48.5 39.5L50 39L52 39.5L53.5 41L54 42.5L53.5 44.5L51 47.5L47 51L42 54L33 55.5L16.5 53Z",
    fill: "#26B8E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.764 45.6633H35.2066C37.6637 45.6633 39.6485 43.8966 39.6485 41.4395C39.6485 39.395 38.2682 37.7633 36.2861 37.2649C33.4504 36.5542 30.6224 35.9963 27.6645 36.0689C22.9763 36.1806 19.6969 38.7958 15.979 41.2811",
    stroke: "#383838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7664 45.7399C33.5074 45.4855 35.2794 45.7426 37.0384 45.701C41.1144 45.605 44.3109 42.157 47.4138 39.8218C48.9989 38.6258 51.22 38.7842 52.621 40.193C54.1776 41.7549 54.1776 44.2869 52.621 45.849C49.2714 49.2165 46.3085 52.3378 41.7656 54.1045C35.461 56.5562 29.6104 55.3655 23.2254 54.1045C20.7555 53.6141 18.4801 53.5855 15.979 53.5855",
    stroke: "#383838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2085 55.9972H12.79C14.7618 55.9972 15.9864 54.6065 15.9864 52.6372V41.11C15.9864 39.1407 14.7618 37.75 12.79 37.75H10.2085",
    stroke: "#383838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7981 6.97009C34.7981 5.42356 33.5446 4.16992 31.9979 4.16992C30.4513 4.16992 29.1978 5.42356 29.1978 6.97009C29.1978 8.51663 30.452 9.76944 31.9984 9.76944C33.545 9.76944 34.7981 8.51663 34.7981 6.97009Z",
    stroke: "#383838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7433 30.0075C12.1926 18.9966 20.9728 9.7666 31.9978 9.7666C43.0227 9.7666 51.8028 18.9966 51.2544 30.0075",
    stroke: "#383838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliableAvailableIcon);
export default __webpack_public_path__ + "static/media/ReliableAvailableIcon.9afd4d39a6563147d05588c1ff881c1f.svg";
export { ForwardRef as ReactComponent };